export default __webpack_public_path__ + "static/tags-anatomy-dark-efba55821aba848eea8525c5c0436d1f0f2ed475bb64d4ac9bf46b2c3c3aea70.png";